import styled from 'styled-components';

import { ANIM, COLORS, FIXED_HEADER, MOBILE_NAV_ANIM, REDUCED_MOTION, SPACE } from '../../../../theme/tokens';
import { MOBILE_NAV_HIDDEN } from '../../../../layouts/MainLayout/mobileNavVisibility';

export { DirtyNote, JobNote, PublishBtn } from '../SeoHeaderActions/SeoHeaderActions.styles';

/**
 * How far above the bottom of the screen the bar rests while the mobile bottom navigation shows: the blog editor's
 * footer bar clearance (the pill's ~104px plus a buffer), so the bar sits clear of it.
 */
export const MOBILE_NAV_CLEARANCE_PX = 134;

/**
 * Publish and Undo pinned to the bottom of the screen on a phone, as the blog editor's footer bar: above the bottom
 * navigation while it shows, following it down to the edge while it is scrolled away.
 */
export const Root = styled.div`
  position: sticky;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${SPACE[12]};
  padding: ${SPACE[12]} ${SPACE[16]} calc(${SPACE[12]} + env(safe-area-inset-bottom));
  border-top: 1px solid ${COLORS.panelBorder};
  border-radius: 16px 16px 0 0;
  background: ${COLORS.surfaceCard};

  ${FIXED_HEADER} {
    bottom: calc(${MOBILE_NAV_CLEARANCE_PX}px + env(safe-area-inset-bottom));
    padding-bottom: ${SPACE[12]};
    border-radius: 16px;
    transition:
      bottom ${MOBILE_NAV_ANIM.hideMs}ms ${ANIM.EASE},
      padding-bottom ${MOBILE_NAV_ANIM.hideMs}ms ${ANIM.EASE};

    ${MOBILE_NAV_HIDDEN} & {
      bottom: 0;
      padding-bottom: calc(${SPACE[12]} + env(safe-area-inset-bottom));
    }

    ${REDUCED_MOTION} {
      transition: none;
    }
  }
`;

/** The note takes the room left of the buttons. */
export const NoteSlot = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;
